import * as Yup from 'yup';

export default Yup.object().shape({
  ratingEnabled: Yup.bool().default(true),
  headline: Yup.string().label('Headline').required().default(''),
  subtitle: Yup.string().label('Subtitle').required().default(''),
});
